import { j as t } from "../../modules/index.es3.js";
import { Root as o, Image as f, Fallback as i } from "../../modules/index.es38.js";
import * as l from "react";
import { cn as m } from "../../utils/styling.es.js";
import { avatarVariant as c } from "./Avatar.styles.es.js";
const d = l.forwardRef(({ size: a, className: e, ...r }, s) => /* @__PURE__ */ t.jsx(
  o,
  {
    ref: s,
    className: m(c({ size: a, className: e })),
    ...r
  }
));
d.displayName = o.displayName;
const u = l.forwardRef(({ className: a, ...e }, r) => /* @__PURE__ */ t.jsx(
  f,
  {
    ref: r,
    className: m("aspect-square h-full w-full", a),
    ...e
  }
));
u.displayName = f.displayName;
const n = l.forwardRef(({ backgroundColor: a, textColor: e, className: r, ...s }, p) => /* @__PURE__ */ t.jsx(
  i,
  {
    ref: p,
    className: m(
      "flex h-full w-full items-center justify-center rounded-full bg-gray-200 text-foreground font-medium text-sm uppercase",
      r
    ),
    style: {
      backgroundColor: a,
      color: e
    },
    ...s
  }
));
n.displayName = i.displayName;
export {
  d as Avatar,
  n as AvatarFallback,
  u as AvatarImage
};
//# sourceMappingURL=Avatar.es.js.map
